module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loginEntrance"
    }
  }, [_c('div', {
    staticClass: "loginEntrance-header"
  }, [_c('img', {
    staticClass: "loginEntrance-header-close",
    attrs: {
      "src": require("../../../assets/icon/close2.png")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "slot": "right",
      "to": "/register"
    },
    slot: "right"
  }, [_c('span', {
    staticClass: "loginEntrance-header-register"
  }, [_vm._v("注册")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "loginEntrance-footer"
  }, [_c('router-link', {
    attrs: {
      "slot": "right",
      "to": "/login",
      "replace": true
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "loginEntrance-footer-login"
  }, [_vm._v("手机号登录")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginEntrance-content"
  }, [_c('img', {
    staticClass: "loginEntrance-content-img",
    attrs: {
      "src": require("../../../assets/icon/login_img.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-054924ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/login/loginEntrance.vue
// module id = 545
// module chunks = 1